export const CREATE_LEDGERMAP = 'CREATE_LEDGERMAP'
export const SAVED_LEDGERMAP = 'SAVED_LEDGERMAP'
export const EDIT_LEDGERMAP = 'EDIT_LEDGERMAP'
export const EDITED_LEDGERMAP = 'EDITED_LEDGERMAP'
export const FETCH_LEDGERMAP = 'FETCH_LEDGERMAP'
export const FETCHED_LEDGERMAP = 'FETCHED_LEDGERMAP'
export const SEARCH_LEDGERMAP = 'SEARCH_LEDGERMAP'
export const STORE_SEARCH_LEDGERMAP_RESULT = 'STORE_SEARCH_LEDGERMAP_RESULT'
export const DELETE_LEDGERMAP = 'DELETE_LEDGERMAP'
export const DELETED_LEDGERMAP = 'DELETED_LEDGERMAP'
export const NOTIFICATION_DONE_LEDGERMAP = 'NOTIFICATION_DONE_LEDGERMAP'
export const FILTER_ITEMS = 'FILTER_ITEMS'
